import styled from 'styled-components';

export const Column = styled.div`
  display: flex;
  width: 100%;
  padding: 1.25rem;
  justify-content: center;
`;
